module.exports = __webpack_public_path__ + "img/gh-12132____-20.prt.84703f29.jpg";